import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-capital',
  templateUrl: './icon-capital.component.html',
  styles: []
})
export class IconCapitalComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
